import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";

export interface ResourceLabel {
	readonly label: { key: string; value: string };
	readonly tooltip: { key: string; value: string };
}

export class LabelResource
	extends BaseCamelCasedResource
	implements ResourceLabel
{
	label: {
		key: string | "";
		value: string | "";
	};
	tooltip: {
		key: string | "";
		value: string | "";
	};

	pk = (): string => this.label?.key || this.tooltip?.key;

	static urlRoot = apiResourceUrl("resources/labels");
}
